"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseEndpointOut = void 0;
class ListResponseEndpointOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ListResponseEndpointOut.attributeTypeMap;
    }
}
exports.ListResponseEndpointOut = ListResponseEndpointOut;
ListResponseEndpointOut.discriminator = undefined;
ListResponseEndpointOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<EndpointOut>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    },
    {
        "name": "prevIterator",
        "baseName": "prevIterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ListResponseEndpointOut.js.map